import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { hideAlert } from "../../state/alert/reducer"
import { RootState } from "../../state/store"
import { Alert } from "./Alert"
import "./AlertList.scss"

const AlertList = () => {
    const dispatch = useDispatch()
    const alerts = useSelector((state: RootState) => state.alerts.active)
    
    return (
        <div className="alert-list">
            {alerts.map(alert => (
                <Alert
                    key={alert.id}
                    variant={alert.type}
                    alertBody={alert.message}
                    onClose={() => dispatch(hideAlert(alert.id))}
                    dismissible={alert.dismissible}
                />
            ))}
        </div>
    )
}

export default AlertList


// WEBPACK FOOTER //
// ./src/common/alert/AlertList.tsx